// components/Blocks/BasicInfoBlock.js
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import user_img from '../../../../../../../img/parents.svg';
import { localDateString  } from '../../../../../../../components/helpers/datetranslate';

const BasicInfoBlock = ({ data, onChange, editable, defaultOpen = false, isViewOnly = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleFieldChange = (field, value) => {
    if (isViewOnly) return;
    onChange(field, value);
  };

  const formatBirthDate = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('uk-UA');
  };

  return (
    <div className="card-block">
      <button
        className="block-header"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="left">
          <img className="blk-icon" src={user_img} alt="" />
          <span className="title">Основна інформація</span>
          {!isOpen && (
            <span className="subtitle">
              {data.fullName}, {formatBirthDate(data.birthDate)}
            </span>
          )}
        </div>
        <FontAwesomeIcon 
          icon={isOpen ? faChevronUp : faChevronDown} 
          className="chevron" 
        />
      </button>
      {isOpen && (
        <div className="block-body">
          <div className="row g-3 align-items-start">
            <div className="col-md-4">
              <div className="form-label">Прізвище</div>
              <input
                type="text"
                className="form-control"
                value={data.lastName || ''}
                onChange={(e) => handleFieldChange('lastName', e.target.value)}
                placeholder="Введіть прізвище"
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-4">
              <div className="form-label">Ім'я</div>
              <input
                type="text"
                className="form-control"
                value={data.firstName || ''}
                onChange={(e) => handleFieldChange('firstName', e.target.value)}
                placeholder="Введіть ім'я"
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-4">
              <div className="form-label">По батькові</div>
              <input
                type="text"
                className="form-control"
                value={data.middleName || ''}
                onChange={(e) => handleFieldChange('middleName', e.target.value)}
                placeholder="Введіть по батькові"
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-6">
              <div className="form-label">Дата народження</div>
              <input
                type="date"
                className="form-control"
                value={data.birthDate ? new Date(data.birthDate).toISOString().split('T')[0] : ''}
                onChange={(e) => handleFieldChange('birthDate', e.target.value)}
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-6">
              <div className="form-label">Стать</div>
              <select
                className="form-select"
                value={data.sex || ''}
                onChange={(e) => handleFieldChange('sex', e.target.value)}
                disabled={isViewOnly || !editable}
              >
                <option value="">Оберіть стать</option>
                <option value="чоловіча">Чоловіча</option>
                <option value="жіноча">Жіноча</option>
              </select>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BasicInfoBlock;